import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSignIn:"isSignIn",
};

export const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    signIn: (state) => {
      state.isSignIn ="isSignIn";
    },
    signup: (state) => {
      state.isSignIn ="isSignUp";
      
    },
  },
});


export const { signIn, signup } = counterSlice.actions;


export default counterSlice.reducer;
